enum ContractTypes {
  oneTime = 'Разовый',
  yearly = 'Годовой',
}

export default ContractTypes;
